import React, { useCallback, useState } from 'react';
import { useInterval } from 'vrlcm-gui-utils';
import { BootstrapApi } from 'vrlcm-gui-api';
import './BootLoader.css';
import BootRect from './BootRect';
import { l10n } from '../with-app-root/i18n/i18nUtil';

const messages = [
  `${l10n('components.bootLoader.message1')}`,
  `${l10n('components.bootLoader.message2')}`,
  `${l10n('components.bootLoader.message3')}`,
  `${l10n('components.bootLoader.message4')}`,
  `${l10n('components.bootLoader.message5')}`,
  `${l10n('components.bootLoader.message6')}`,
  `${l10n('components.bootLoader.message7')}`,
  `${l10n('components.bootLoader.message8')}`
];

interface Props {
  status?: 'FAILED' | 'INPROGRESS' | 'WAITING' | null;
}

const BootLoader: React.FC<Props> = props => {
  const { status } = props;
  const items = new Array(4).fill(0).map((_, i) => i * 32);
  const [index, setIndex] = useState(0);
  const message = messages[index];

  const updateMessage = useCallback(() => {
    setIndex(p => (p === messages.length - 1 ? 0 : p + 1));
  }, []);

  useInterval(updateMessage, 3000);

  const downloadLogs = async () => {
    await BootstrapApi.downloadBootstrapLogs();
  };

  const handleTextOverflow = (text: string) => {
    if (text.length > 60) {
      return text.substring(0, 60) + '...';
    }
    return text;
  };

  return (
    <div className="boot-loader">
      <svg width="512" height="452">
        <title>{l10n('components.bootLoader.bootLoaderImage')}</title>
        <g fill="none" fillRule="evenodd">
          <path
            d="M512.001 300.138H0V30.897C0 13.833 13.833 0 30.897
            0h450.207c17.064 0 30.897 13.833 30.897 30.897v269.241z"
            fill="#38454F"
            fillRule="nonzero"
          />
          <path
            d="M481.103 370.759H30.897C13.833 370.759 0 356.926 0 339.862v-39.724h512v39.724c0
           17.064-13.833 30.897-30.897 30.897"
            fill="#E8EDEE"
            fillRule="nonzero"
          />
          <ellipse fill="#B0B6BB" cx="256" cy="335.845" rx="9" ry="9.5" />
          <path fill="#B0B6BB" d="M226 370.345h62v66h-62z" />
          <rect fill="#E8EDEE" x="167" y="436" width="179" height="16" rx="7" />
          {status === 'INPROGRESS' ? (
            <>
              <g transform="matrix(1 0 0 1 160 95)" fill="#ebba17">
                {items.map(i => (
                  <BootRect key={i / 32} y={i} />
                ))}
              </g>
              <g
                fontFamily="Helvetica"
                fontSize="14"
                transform="translate(256 256)"
              >
                <text fill="#FFF" textAnchor="middle">
                  <title>{message}</title>
                  <tspan y="14">{handleTextOverflow(message)}</tspan>
                </text>
              </g>
            </>
          ) : (
            <>
              {status === 'FAILED' ? (
                <g
                  transform="translate(175 226)"
                  className="download-logs"
                  onClick={downloadLogs}
                >
                  <rect
                    stroke="#C74343"
                    fill="#FFE6E6"
                    x=".5"
                    y=".5"
                    width="162"
                    height="36"
                    rx="8"
                  />
                  <text fill="#C74343" fontFamily="Helvetica" fontSize="12">
                    <title>{l10n('components.bootLoader.downloadLogs')}</title>
                    <tspan x="40.639" y="22">
                      {handleTextOverflow(
                        l10n('components.bootLoader.downloadLogs')
                      )}
                    </tspan>
                  </text>
                </g>
              ) : (
                <g
                  fontFamily="Helvetica"
                  fontSize="14"
                  transform="translate(256 256)"
                >
                  <text fill="#FFF" textAnchor="middle">
                    <title>
                      {l10n('components.bootLoader.waitingForServicesToStart')}
                    </title>
                    <tspan y="14">
                      {handleTextOverflow(
                        l10n('components.bootLoader.waitingForServicesToStart')
                      )}
                    </tspan>
                  </text>
                </g>
              )}
              <g transform="translate(207 82)">
                <circle
                  stroke="#C74343"
                  fill="#F78F8F"
                  cx="50"
                  cy="50"
                  r="49.5"
                />
                <text fontFamily="Helvetica" fontSize="72" fill="#FFF">
                  <tspan x="39.498" y="76">
                    !
                  </tspan>
                </text>
              </g>
            </>
          )}
        </g>
      </svg>
    </div>
  );
};

export default BootLoader;
